import React, { useEffect, useState } from 'react';
import { useTailwind } from 'tailwind-rn';
import { Text, StyleSheet, Image, Button, View, TouchableOpacity,SafeAreaView } from 'react-native';
import Modal from "react-native-modal";

const Slideshow = ({list, startIndex = 0}) => {
    const tailwind = useTailwind();

    
    const [isLoading, setLoading] = useState(true);
    const [actualImage, setImage] = useState("http://static.sumaysigue.uchile.cl/MASonline/bundles/IPG%20RTA4/Capturas/cap0.PNG");
    const [actualCaption, setCaption] = useState("Caption 0");
    const [actualIndex, setIndex] = useState(0);
    const [quantyIndex, setQuantyIndex] = useState(0);

    const [isModalVisible, setModalVisible] = useState(false);

    const toggleModal = () => {
        setModalVisible(!isModalVisible);
    };


    console.log("---------------- Slideshow -----------------");
    console.log(list)
    console.log(list.length)
    
    async function autoSlide() {
        console.log("autoSlide");
        goRigth();
    }


    let changeImage = (object) => {
        console.log("presionado");
        setImage("http://static.sumaysigue.uchile.cl/MASonline/bundles/IPG%20RTA4/Capturas/cap1.PNG");

    }

    let goRigth = (object) => {
        console.log("presionado siguiente");
        console.log(actualIndex);
        
        if( actualIndex == (quantyIndex - 1) )
        {
            setIndex(0);
        }else
        {
            setIndex(actualIndex+1);
        }
        UpdateSlide();

    }

    let goLeft = (object) => {
        console.log("presionado siguiente");
        console.log(actualIndex);
        
        if( actualIndex == 0 )
        {
            setIndex(quantyIndex - 1);
        }else
        {
            setIndex(actualIndex-1);
        }
        
        UpdateSlide();
    }

    let UpdateSlide = () => {

        console.log("Setear slide:");
        console.log(actualIndex);

        setImage(list[actualIndex]["imageurl"]);
        setCaption(list[actualIndex]["caption"]);
    }

    useEffect(() => {

        console.log("use Effect");
        console.log(list);
        setQuantyIndex(list.length);
        console.log("numero slide inicial");
        console.log(startIndex);
        setIndex(startIndex);
        UpdateSlide();
        console.log("cantidad de slides:");
        console.log(quantyIndex);

        autoSlide();
        
      }, []);

      //setInterval(autoSlide, 6000);
    
  
  
    return(
        <View style ={ tailwind("w-full h-full justify-around items-center") }>
            <TouchableOpacity style={{width: '80%',height: '80%'}}  onPress={ toggleModal }>
                <Image
                    style = {{ width: '100%',height: '100%', resizeMode: 'contain' }}
                    source = {{ uri: actualImage }}
                />
            </TouchableOpacity>
            <View>
                <Text>{actualCaption}</Text>
            </View>
            <View style={ tailwind("flex flex-row flex-wrap justify-evenly") }>
                    <Button
                    title= {"<"} 
                    onPress= { goLeft }
                    onClick= { goLeft }
                />
                <Text>Controls</Text>
                <Button
                    title= {">"} 
                    onPress= { goRigth }
                    onClick= { goRigth }
                />
            </View>
            <Modal 
                isVisible={ isModalVisible }
                onBackdropPress={ toggleModal }
            >
                <SafeAreaView style={{ flex: 1 }}>
                    <Image
                        style = {{ width: '100%',height: '100%', resizeMode: 'contain' }}
                        source = {{ uri: actualImage }}
                    />
                    <View style={ tailwind("flex flex-row flex-wrap justify-evenly") }>
                        <Button
                            title= {"<"} 
                            onPress= { goLeft }
                            onClick= { goLeft }
                        />
                        <Text>Controls</Text>
                        <Button
                            title= {">"} 
                            onPress= { goRigth }
                            onClick= { goRigth }
                        />
                    </View>
                    <Button title="Ok" onPress={ toggleModal } />
                </SafeAreaView>
            </Modal>
        </View>
    );
    
};

const styles = StyleSheet.create({
    container: { flex: 1, backgroundColor: 'white', padding: 12, width:"100%",height:"100%"},
    //child: { width, height: '100%', justifyContent: 'center' },
    //image: { height: height * 0.65, width:"100%",resizeMode: 'contain' },
    //text: { textAlign: 'center', paddingBottom: 24 },  
});
  

  

export default Slideshow;